import { render } from "./IntegrationsDashboard.vue?vue&type=template&id=f0ca2b80&scoped=true"
import script from "./IntegrationsDashboard.vue?vue&type=script&lang=js"
export * from "./IntegrationsDashboard.vue?vue&type=script&lang=js"

import "./IntegrationsDashboard.vue?vue&type=style&index=0&id=f0ca2b80&lang=postcss&scoped=true"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0ca2b80"]])

export default __exports__